export const common = {
  // Navigation
  nav: {
    home: 'Accueil',
    freshFish: 'Poissons Frais',
    grilledFish: 'Poissons Braisés',
    about: 'À Propos',
    contact: 'Contact',
    supplier: 'Fournisseur',
    cart: 'Panier'
  },
  // Hero
  hero: {
    title: 'Produits de pêche journalière et grillades de qualité',
    description: 'Découvrez notre sélection de poissons ultra-frais pêchés quotidiennement et nos délicieux poissons braisés préparés selon la tradition camerounaise.',
    delivery: 'Livraison rapide dans tout Douala.',
    principle: 'Principe: Pour garantir la disponibilité, commandez la veille, à partir de 3kg de chaque, et laissez vous conseiller.',
    orderFresh: 'Commander Poissons Frais',
    viewGrilled: 'Voir Poissons Braisés'
  },
  // Fresh Fish Section
  freshFish: {
    title: 'Poissons Frais du Jour',
    description: 'Sélection quotidienne de poissons ultra-frais. Ajoutez vos produits au panier et finalisez votre commande via WhatsApp pour une livraison rapide à Douala.',
    tagline: 'Eat Fresh offre les produits de mer, chaque jour et toujours frais....',
    fresh: 'Frais',
    addToCart: 'Ajouter au panier',
    perKg: 'FCFA/kg',
    perPiece: 'FCFA/pièce',
    onRequest: 'Sur demande'
  },
  // Grilled Fish Section
  grilledFish: {
    title: 'Poissons Braisés Traditionnels',
    description: 'Savourez nos poissons braisés préparés selon la tradition camerounaise. Parfaits pour vos repas en famille ou entre amis.',
    deliveryInfo: 'Poisson braisé traditionnel, livré à partir de 18h chez vous.',
    salesPoints: 'Points de ventes: Makepe BM, Makepe derrière Afriland rond Poulenc',
    deliveryZones: 'Zones de livraisons: Douala 5 ème',
    accompaniments: 'Accompagnements disponibles :',
    accompanimentsList: 'Frites de plantain • Miondo • Bobolo',
    eventService: 'Service Événementiel',
    eventDescription: 'Notre équipe est disponible pour vos événements : mariages, anniversaires, réceptions d\'entreprise et toutes vos célébrations spéciales.',
    grilled: 'Braisé',
    addToCart: 'Ajouter au panier'
  },
  // About Section
  about: {
    title: 'Pourquoi Choisir Eat Fresh by 2π ?',
    description: 'Depuis notre création, nous nous engageons à fournir les poissons les plus frais de Douala. Notre équipe sélectionne quotidiennement les meilleurs produits pour garantir votre satisfaction.',
    freshness: 'Fraîcheur Garantie',
    freshnessDesc: 'Poissons pêchés quotidiennement et livrés le jour même',
    quality: 'Qualité Supérieure',
    qualityDesc: 'Sélection rigoureuse des meilleurs produits de la mer',
    delivery: 'Livraison Rapide',
    deliveryDesc: 'Toute commande à la veille livrée à tout moment de la journée.',
    traditional: 'Préparation Traditionnelle',
    traditionalDesc: 'Poissons braisés selon les recettes camerounaises authentiques',
    salesConditions: 'Conditions de Vente',
    condition1: 'La commande n\'est garantie que par la disponibilité du stock',
    condition2: 'Remboursement assuré en cas de non disponibilité si la commande a été validée et l\'argent encaissé'
  },
  // Contact Section
  contact: {
    title: 'Contactez-nous',
    description: 'Nous sommes à votre écoute pour toute question ou commande spéciale',
    phone: 'Téléphone',
    whatsapp: 'WhatsApp',
    address: 'Adresse',
    addressValue: 'Douala, Cameroun',
    hours: 'Horaires d\'Ouverture',
    everyday: 'Tous les jours',
    freshFishHours: 'Poisson frais : à partir de 7h30',
    grilledDeliveryHours: 'Livraison grillades : à partir de 18h00'
  },
  // Footer
  footer: {
    description: 'Votre source de confiance pour les poissons frais et braisés de qualité à Douala.',
    navigation: 'Navigation',
    contact: 'Contact',
    hours: 'Horaires',
    everyday: 'Tous les jours',
    freshFishHours: 'Poisson frais : dès 7h30',
    grilledDeliveryHours: 'Livraison grillades : dès 18h',
    rights: '© 2024 Eat Fresh by 2π. Tous droits réservés.',
    poweredBy: 'WOW (WhatsApp Order Website) powered by Wazi Consulting'
  },
  // Cart
  cart: {
    title: 'Mon Panier',
    empty: 'Votre panier est vide',
    unitPrice: 'Prix unitaire',
    total: 'Total',
    clearCart: 'Vider le panier',
    finalizeWhatsApp: 'Finaliser sur WhatsApp',
    kg: 'kg',
    pieces: 'pièce',
    comment: 'Commentaire (optionnel)',
    commentPlaceholder: 'Ajoutez un commentaire pour votre commande...',
    characters: 'caractères',
    priceNote: 'Les prix peuvent varier selon la disponibilité et la taille. Le prix final sera confirmé lors de la préparation de votre commande.',
    recipientInfo: 'Nom et numéro du destinataire',
    recipientPlaceholder: 'Ex: Jean Dupont - 690123456',
    paymentNumbers: 'Numéros de paiement',
    orderSent: 'Commande envoyée !',
    orderSentDesc: 'Votre commande a été envoyée via WhatsApp. Nous vous contacterons bientôt pour confirmer.',
    understood: 'Compris !'
  },
  // Supplier
  supplier: {
    title: 'Espace Fournisseur',
    description: 'Renseignez vos informations et enregistrez votre stock de poissons frais du jour',
    supplierInfo: 'Informations du fournisseur',
    firstName: 'Prénom',
    lastName: 'Nom',
    phone: 'Numéro de téléphone',
    addFish: 'Ajouter un poisson',
    fishType: 'Type de poisson',
    selectFish: 'Sélectionner un poisson',
    quantity: 'Quantité (kg)',
    price: 'Prix (FCFA/kg)',
    addToStock: 'Ajouter au stock',
    dailyStock: 'Stock du jour',
    clearAll: 'Tout vider',
    noFish: 'Aucun poisson ajouté',
    totalAvailable: 'Total disponible',
    sendWhatsApp: 'Envoyer le stock via WhatsApp',
    fillAllFields: 'Veuillez remplir tous les champs',
    addAtLeastOne: 'Veuillez ajouter au moins un poisson au stock',
    fillPersonalInfo: 'Veuillez renseigner vos informations personnelles',
    confirmClear: 'Voulez-vous vraiment vider tout le stock ?'
  },
  // WhatsApp Messages
  whatsapp: {
    freshOrder: 'Commande Poissons Frais',
    grilledOrder: 'Commande Poissons Braisés',
    quantity: 'Quantité',
    unitPrice: 'Prix unitaire',
    total: 'Total',
    toConfirm: 'À confirmer',
    onRequest: 'Sur demande',
    comment: 'Commentaire',
    priceNote: 'Note: Les prix sont indicatifs et peuvent varier.',
    confirmOrder: 'Merci de confirmer ma commande et m\'indiquer les modalités de livraison.',
    stockTitle: 'Stock Poissons Frais du Jour',
    date: 'Date',
    supplier: 'Fournisseur',
    phone: 'Téléphone',
    totalAvailable: 'Total',
    kgAvailable: 'kg disponibles',
    sentBySupplier: 'Stock envoyé par le fournisseur'
  },
  // Products
  products: {
    bar: 'Bar Frais',
    barDesc: 'Bar de mer frais, poisson noble pour occasions spéciales',
    bossus: 'Bossus Frais',
    bossusDesc: 'Bossus frais, chair tendre et délicate, poisson local de qualité',
    brochet: 'Brochet',
    brochetDesc: 'Brochet frais du jour, poisson d\'eau douce de qualité, chair ferme et savoureuse, idéal pour vos recettes',
    capitaine: 'Capitaine',
    capitaineDesc: 'Capitaine frais du jour, poisson local de qualité, chair ferme et savoureuse',
    carangue: 'Carangue',
    carangueDesc: 'Carangue fraîche du jour, poisson de mer savoureux, vendu au kg de qualité supérieure',
    carpe: 'Carpe Fraîche',
    carpeDesc: 'Carpe fraîche du jour, parfaite pour vos recettes traditionnelles',
    crabes: 'Crabes',
    crabesDesc: 'Crabes frais de qualité supérieure, chair savoureuse et délicate, parfaits pour vos plats de fruits de mer',
    crevettes: 'Crevettes roses',
    crevettesDesc: 'Crevettes roses fraîches de qualité supérieure, chair tendre et savoureuse',
    dorade: 'Dorade grise',
    doradeDesc: 'Daurade royale fraîche, saveur raffinée et texture parfaite',
    escargot: 'Escargot',
    escargotDesc: 'Escargots frais de qualité supérieure, délicatesse locale appréciée pour sa saveur unique',
    escargotCleaned: 'Escargot nettoyé',
    escargotCleanedDesc: 'Escargots nettoyés et prêts à cuisiner, qualité premium pour vos recettes raffinées',
    gambas: 'Gambas',
    gambasDesc: 'Gambas fraîches de qualité supérieure, idéales pour vos plats de fruits de mer',
    machoiron: 'Machoiron Frais',
    machoironDesc: 'Machoiron de première qualité, idéal pour grillades et sauces',
    mulet: 'Mulet',
    muletDesc: 'Mulet frais du jour, poisson savoureux et polyvalent, parfait pour toutes vos préparations culinaires',
    sole: 'Sole Fraîche',
    soleDesc: 'Sole fraîche, poisson plat délicat, parfait pour les enfants',
    tilapia: 'Tilapia',
    tilapiaDesc: 'Tilapia frais du jour, poisson d\'eau douce savoureux et polyvalent, parfait pour toutes vos préparations',
    barGrilled: 'Bar Braisé',
    barGrilledDesc: 'Bar de mer braisé, préparation premium pour connaisseurs',
    capitaineGrilled: 'Capitaine Braisé',
    capitaineGrilledDesc: 'Capitaine braisé à la perfection avec nos épices spéciales',
    carpeGrilled: 'Carpe Braisée',
    carpeGrilledDesc: 'Carpe braisée marinée aux herbes locales',
    machoironGrilled: 'Machoiron Braisé',
    machoironGrilledDesc: 'Machoiron grillé sauce pimentée, un délice camerounais',
    maquereauGrilled: 'Maquereau Braisé',
    maquereauGrilledDesc: 'Maquereau braisé aux épices traditionnelles, saveur authentique',
    silureGrilled: 'Silure Braisée',
    silureGrilledDesc: 'Silure braisé tendre et savoureux, préparé avec soin',
    soleGrilled: 'Sole Braisée',
    soleGrilledDesc: 'Sole braisée délicatement préparée, chair tendre et savoureuse',
    brochette: 'Brochette de porc braisé',
    brochetteDesc: 'Brochette de porc grillée à la perfection, viande tendre et savoureuse'
  }
};
